import type { ApiTarget } from "../Types/Generated/LogbookApi/ApiRuntime"
import type { ILogbookSession, ISessionResponse } from "../Types/Generated/LogbookModel/Session"
import { ILogbookSessionType } from "../Types/Generated/LogbookModel/Session"
import type { FetchResult } from "./Connections"
import { normalizeAccountUser } from "./Connections/AccountUser"

export function accountSessionResult(response: ISessionResponse): FetchResult {
  const { session } = response;
  const account = response.account;
  const accountId = session.accountId;
  const userId = session.userId;
  const accountUser = session.authorized
    && response.type === ILogbookSessionType.cloud
    && accountId !== undefined
    && userId !== undefined
    && response.accountUserLevel !== undefined
    ? normalizeAccountUser({
        accountId,
        userId,
        accountLevel: response.accountUserLevel,
      })
    : undefined;
  const accounts = session.authorized && account !== undefined && account.id === accountId
    ? [account]
    : [];

  return {
    entities: {
      Account: accounts,
      AccountUser: accountUser ? [accountUser] : [],
    },
    authoritative: accountId === undefined || userId === undefined
      ? undefined
      : { AccountUser: { accountId, userId } },
  };
}

export function accountSessionIdentity(
  session: ILogbookSession | undefined,
  type: ILogbookSessionType | undefined,
  target: ApiTarget,
): string {
  if (!session?.authorized) {
    return `${target}:unauthorized`;
  }
  return [
    target,
    type ?? "unknown",
    session.id ?? "no-session-id",
    session.accountId ?? "no-account",
    session.userId ?? "no-user",
  ].join(":");
}
